<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Transaksi Harian</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <b-form-group label="Cabang">
                        <div class="mr-2">
                            <multiselect
                                name="cabang"
                                v-model="input.cabang" 
                                :options="cabangOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih Cabang --"
                            />
                        </div>
                    </b-form-group>
                    <b-form-group label="Tanggal" class="small-input-date">
                        <div class="d-flex search-input-wrapper">
                            <b-form-input v-model="input.tanggal" name="tanggal" type="date" :max="maxDate" required></b-form-input>
                        </div>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="submitLaporan" variant="pgiBtn">Cetak</b-button>
                </div>
            </b-form>

            <div v-if="urlGadai != null">
                <p class="smallText text-muted">
                    Bila laporan tidak muncul setelah lebih dari 30 detik / hanya menampilkan warna abu-abu dengan error, klik 
                    <a :href="urlGadai" target="_blank">link</a> ini, atau hubungi HO.
                </p>
                <iframe width="100%" height="1000" :src= urlGadai frameborder="0" allowfullscreen></iframe>
            </div>
        </b-card>
        <ModalConfirm id="modal-confirm-cetak" title="Confirm Cetak Laporan Transaksi Harian" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mencetak laporan transaksi harian?" @submit="onSubmit" />
    </div>
</template>

<script>
export default {
    name: 'transaksi-harian',
    data(){
        return{
            isSubmitting: false,
            cabang: null,
            input: {
                cabang: null,
                tanggal: null
            },
            cabangOption: [],
            urlGadai: null,
            maxDate: null
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.cabangOption = this.$helper.getAllCabang()

            let date = new Date().toISOString().slice(0,10)
            this.input.tanggal = date

            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth()+1; //January is 0!
            var yyyy = today.getFullYear();
            if(dd<10){
                    dd='0'+dd
                } 
                if(mm<10){
                    mm='0'+mm
                } 

            today = yyyy+'-'+mm+'-'+dd;
            this.maxDate = today
        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit() {
            this.isSubmitting = true

            this.$axios.get("laporan-cabang-harian/transaksi-harian-v2/?cabangId="+this.input.cabang.id+"&tanggal="+this.input.tanggal).then(response => {
                this.urlGadai = this.$baseFilePath+response.data
                this.$bvModal.hide("modal-confirm-cetak")
                this.$helper.toastSucc(`Laporan transaksi harian berhasil dibuat!`)
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            if (this.input.cabang == null || !this.$helper.isNotNullAndNotEmpty(this.input.tanggal)){
                this.$helper.toastErr(this, "Mohon lengkapi data untuk cetak laporan!")
            } else {
                this.$bvModal.show("modal-confirm-cetak")
            }            
        }
    },

    created(){
        this.init()
    }
}
</script>
